export default "__VITE_ASSET__DAaCVlwq__"